<template>
  <div>
    <!-- TODO: refactor markup Header Component-->
    <b-navbar  type="light" fixed="top" toggleable="lg" class="navbar-default py-3">
      <b-container class="px-0">
        <b-navbar-brand href="#">
          <img src="@/assets/images/logos/logo.png" alt="logo"/>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <mainMenu></mainMenu>
          <Languages/>
          <b-navbar-nav class="my-3 my-sm-0 ml-2 nav-user align-items-center d-flex flex-row justify-content-center">
            <userData></userData>
            <secondaryMenu></secondaryMenu>
          </b-navbar-nav>
        </b-collapse>
      </b-container>
    </b-navbar>

  </div>
</template>

<script>
import mainMenu from './main_menu'
import secondaryMenu from './secondary_menu'
import userData from './user_data'
import Languages from '@/shared/components/languages'

export default {
  name: 'privateHeader',
  components: { mainMenu, secondaryMenu, userData, Languages }
}
</script>
